import React from "react";
var __jsx = React.createElement;
import styled from 'styled-components';
import { Picture, breakpoint, color, stickers, styles as S } from '@bob/design-system';
export function Head(_ref) {
  var _article$forceUpdated, _article$firstPublish;

  var article = _ref.article,
      readTime = _ref.readTime;
  return __jsx(Section, null, __jsx(Block, null, __jsx(S.heading.Title3, {
    as: "h1"
  }, article.title), __jsx(S.heading.Title4, {
    as: "h1"
  }, article.title), article.forceUpdatedAt ? __jsx(PublishedAt, null, "Mis \xE0 jour le", ' ', new Date((_article$forceUpdated = article.forceUpdatedAt) !== null && _article$forceUpdated !== void 0 ? _article$forceUpdated : '').toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  })) : __jsx(PublishedAt, null, "publi\xE9 le", ' ', new Date((_article$firstPublish = article.firstPublishedAt) !== null && _article$firstPublish !== void 0 ? _article$firstPublish : '').toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  })), __jsx(ReadTime, null, __jsx(Line, {
    height: "22",
    width: "2"
  }, __jsx("line", {
    stroke: "black",
    x1: "0",
    y1: "-1",
    x2: "0",
    y2: "21",
    strokeWidth: "2px"
  })), "temps de lecture: ", readTime && __jsx("span", null, readTime, " min"))), __jsx(S.heading.TitleCard, null, article.hat), __jsx(Square, null, __jsx(ResponsiveSticker, null, __jsx(SectionSticker, {
    section: article.section
  })), __jsx(Picture, {
    src: article.image.src
  }), article.image.credit && __jsx(S.copy.TextInfo, {
    dangerouslySetInnerHTML: {
      __html: article.image.credit
    }
  })));
}

function SectionSticker(_ref2) {
  var section = _ref2.section;

  switch (section) {
    case 'Actus':
      return __jsx(stickers.blog.News, null);

    case 'Guide de la consommation responsable':
      return __jsx(stickers.blog.Guide, null);

    case 'Histoires de créateurs et créatrices':
      return __jsx(stickers.blog.Creator, null);

    default:
      return __jsx(React.Fragment, null);
  }
}

var Section = styled.section.withConfig({
  displayName: "Head__Section",
  componentId: "sc-njri11-0"
})(["display:grid;position:relative;@media screen and (", "){display:flex;flex-direction:column;margin-bottom:80px;min-height:415px;width:100%;}@media screen and (", "){height:0;min-height:0px;padding-bottom:50%;}", "{margin-top:25px;margin-bottom:10px;@media screen and (", "){display:none;}}", "{@media not screen and (", "){display:none;}@media screen and (", "){margin-bottom:10px;padding-right:80px;}}", "{order:1;font-size:20px;line-height:23.6px;@media screen and (", "){order:auto;width:50%;margin-bottom:0px;margin-top:26px;padding-right:80px;}}", "{z-index:0;position:absolute;top:0;bottom:0;right:0;left:0;border-radius:12px;overflow:hidden;}"], breakpoint.TABLET, breakpoint.LAPTOP, S.heading.Title3, breakpoint.TABLET, S.heading.Title4, breakpoint.TABLET, breakpoint.TABLET, S.heading.TitleCard, breakpoint.TABLET, Picture);
var Block = styled.div.withConfig({
  displayName: "Head__Block",
  componentId: "sc-njri11-1"
})(["position:relative;@media screen and (", "){width:50%;}"], breakpoint.TABLET);
var Square = styled.div.withConfig({
  displayName: "Head__Square",
  componentId: "sc-njri11-2"
})(["position:relative;height:0;width:100%;padding-bottom:100%;margin:30px 0px 45px;@media screen and (", "){margin:0px;padding-bottom:50%;position:absolute;right:0;top:0;width:50%;}", "{left:0%;position:absolute;top:102%;width:100%;@media screen and (", "){top:101%;text-indent:14%;text-align:right;}}"], breakpoint.TABLET, S.copy.TextInfo, breakpoint.TABLET);
var Line = styled.svg.withConfig({
  displayName: "Head__Line",
  componentId: "sc-njri11-3"
})(["display:none;@media screen and (", "){display:inline;margin:0px 8px;}"], breakpoint.TABLET);
var ResponsiveSticker = styled.div.withConfig({
  displayName: "Head__ResponsiveSticker",
  componentId: "sc-njri11-4"
})(["z-index:20;position:absolute;top:0px;right:5%;display:flex;align-items:center;justify-content:center;height:0px;width:33%;padding-bottom:33%;@media screen and (", "){right:initial;top:initial;bottom:-21%;left:-15%;}", "{position:absolute;height:100%;width:100%;}"], breakpoint.TABLET, stickers.Sticker);
var ReadTime = styled.div.withConfig({
  displayName: "Head__ReadTime",
  componentId: "sc-njri11-5"
})(["@media screen and (", "){color:", ";display:inline;}"], breakpoint.TABLET, color.GRAY_2);
var PublishedAt = styled.time.withConfig({
  displayName: "Head__PublishedAt",
  componentId: "sc-njri11-6"
})(["margin-bottom:2px;"]);